import { Component, Input, HostBinding } from '@angular/core'

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[icon]',
  template: `<svg><use attr.xlink:href="/assets/icons.svg#{{icon.split(' ')[0]}}"></use></svg>`,
  styleUrls: [ './icon.component.scss' ]
})
export class IconComponent {
  @HostBinding('attr.icon') @Input() icon = ''
}

